module.exports = __webpack_public_path__ + "static/media/fab-phone.7810cddc.svg";